'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  position: absolute;\n  width: 24%;\n  height: 24%;\n  right: 0;\n  bottom: 0;\n  border-radius: 50%;\n  border: 1px solid ' + theme.colors.base.background + ';\n  display: none;\n';
};

var modifierConfig = {
  danger: function danger(_ref2) {
    var theme = _ref2.theme;
    return '\n    background-color: ' + theme.colors.status.danger + ';\n    display: block;\n  ';
  },

  info: function info(_ref3) {
    var theme = _ref3.theme;
    return '\n    background-color: ' + theme.colors.status.info + ';\n    display: block;\n  ';
  },

  success: function success(_ref4) {
    var theme = _ref4.theme;
    return '\n    background-color: ' + theme.colors.status.success + ';\n    display: block;\n  ';
  },

  warning: function warning(_ref5) {
    var theme = _ref5.theme;
    return '\n    background-color: ' + theme.colors.status.warning + ';\n    display: block;\n  ';
  }
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

var Status = (0, _decisivUiUtils.buildStyledComponent)('Status', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

Status.modifiers = modifierConfig;

exports.default = Status;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Avatar/Status.js
// module id = 1539
// module chunks = 2